import { render, staticRenderFns } from "./DisplayFilesList.vue?vue&type=template&id=13548a96"
import script from "./DisplayFilesList.vue?vue&type=script&lang=ts"
export * from "./DisplayFilesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports